export const isUploadCsvTemplate = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (user.is_zebeler) {
    return true;
  }

  // E2e user
  if (user.username === 'terry@tehranbuilders.com') {
    return true;
  }

  return false;
};

export const isRecalculateEstimate = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (['tyson@zebel.io', 'jake@zebel.io'].includes(user.username)) {
    return true;
  }
  return false;
};

export const isPdfHtmlExport = () => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  return false;
};

export const isCustomAgentsEnabled = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (user.username.endsWith('@zebel.io')) {
    return true;
  }

  // E2e users — the editor (terry) drives the add/edit flows, the viewer (val) drives
  // roles.spec.js, which needs the Custom Agents section to render so it can assert the
  // controls are disabled rather than absent.
  if (['terry@tehranbuilders.com', 'val@tehranbuilders.com'].includes(user.username)) {
    return true;
  }

  return false;
};

export const isAiAgentsV2 = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (['tyson@zebel.io', 'jake@zebel.io'].includes(user.username)) {
    return true;
  }

  // E2e user
  if (user.username === 'terry@tehranbuilders.com') {
    return true;
  }

  return false;
};

export const isCleanupCostDataEnabled = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (user.username.endsWith('@zebel.io')) {
    return true;
  }

  // E2e user
  if (user.username === 'terry@tehranbuilders.com') {
    return true;
  }

  return false;
};

// A DCS is an onboarding tool a Zebeler fills in on a customer's behalf, so a Zebeler is
// who it is for in production. The other two clauses are what make it drivable: a
// developer working locally is a company user in the seeds, not a Zebeler, and so is the
// user the Playwright suite authenticates as.
//
// This is a UI flag only, by Tyson's call on the story: every `/company-dcs` route on
// the API is still gated on the Zebeler ROLE. So it decides what is offered, not what is
// allowed, and a non-Zebeler who reaches the page sees the list's error state.
export const isCompanyDcsEnabled = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (user.is_zebeler) {
    return true;
  }

  // E2e user
  if (user.username === 'terry@tehranbuilders.com') {
    return true;
  }

  return false;
};

// Auto Assign Market Data proposes a market link for every cost or design field on a record
// or template, and applies the ones a human accepts. A Zebeler is who it is for: the proposals
// are only as good as the market catalogue behind them, and a Zebeler is who curates that. The other two clauses are what make it drivable — a developer working locally is a
// company user in the seeds, and so is the user the Playwright suite authenticates as.
//
// UI only, the same as every other flag here. `POST /field/propose-market-links` is an 'editor'
// route, so opening the feature to customers later is this function and nothing else.
export const isAutoAssignMarketDataEnabled = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (user.is_zebeler) {
    return true;
  }

  // E2e user
  if (user.username === 'terry@tehranbuilders.com') {
    return true;
  }

  return false;
};

// Plan graphs: Analyze on the viewer, and Auto (generate a walkthrough from the graph)
// in the Add Walkthrough dialog. The job runs on Cloud Run Jobs in deployed environments
// (sc-10255) and on the docker compose profile `plan-graph` locally. Released to Zebelers
// (sc-10440): the role, not the zebel.io domain, decides. A UI flag only; the `/plan-graph`
// routes stay role-gated on the API.
export const isPlanGraphEnabled = (user) => {
  if (process.env.NODE_ENV === 'development') {
    return true;
  }
  if (user.is_zebeler) {
    return true;
  }
  // The e2e editor, so the Build button's processing gate is specced against CI's production
  // build. Seeded only; no real account uses this address.
  if (user.username === 'terry@tehranbuilders.com') {
    return true;
  }
  return false;
};

// The in-app assistant panel (T-470): Tyson and Jake only while it is tried out. A
// deliberate exception to the flags above: no development clause and no e2e user. The
// API's agent-conversation routes stay role 'zebeler', so anyone else this admitted would
// see the panel and get a 403 on every request. The e2e specs log in as jake@zebel.io.
export const isAgentChatEnabled = (user) => ['tyson@zebel.io', 'jake@zebel.io'].includes(user.username);
